/**
 * <set-builder>  —  sections/set-builder.liquid
 *
 * Sepete ekleme YOLU YENIDEN YAZILMIYOR: form gercek bir {% form 'product' %}
 * oldugu icin assets/product-form.js tum isi yapiyor (Section Rendering API,
 * sepet drawer'ini acma, pub/sub). Bu dosyanin isi secim durumunu yonetmek ve
 * form gonderilmeden once gizli property alanlarini yazmak.
 *
 * customElements.define kullanilmasi sart: tema sepet drawer'ini sunucudan
 * yeniden ciziyor ve bu bilesen yeniden DOM'a girdiginde connectedCallback ile
 * kendini toparlamali.
 */
if (!customElements.get("set-builder")) {
  customElements.define(
    "set-builder",
    class SetBuilder extends HTMLElement {
      connectedCallback() {
        this.max = Number(this.dataset.picksRequired) || 5;
        this.allowDupes = this.dataset.allowDuplicates === "true";
        this.picks = [];

        this.grid = this.querySelector("[data-set-builder-grid]");
        this.chips = this.querySelector("[data-set-builder-chips]");
        this.counter = this.querySelector("[data-set-builder-counter]");
        this.propsHost = this.querySelector("[data-set-builder-properties]");
        this.variantInput = this.querySelector("[data-set-builder-variant]");
        this.submitButton = this.querySelector("[data-set-builder-submit]");
        this.ctaLabel = this.querySelector("[data-set-builder-cta-label]");
        this.form = this.querySelector("form");
        this.moreButton = this.querySelector("[data-set-builder-more]");

        if (!this.grid || !this.form) return;

        this.size = {
          id: this.variantInput?.value || "",
          label: this.querySelector("[name^='set-size-']:checked")?.dataset.label || "",
        };

        this.onGridChange = this.onGridChange.bind(this);
        this.onChipClick = this.onChipClick.bind(this);
        this.onSizeChange = this.onSizeChange.bind(this);
        this.onSubmitCapture = this.onSubmitCapture.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.searchInput = this.querySelector("[data-set-builder-search]");
        this.searchStatus = this.querySelector("[data-set-builder-search-status]");
        this.emptyMessage = this.querySelector("[data-set-builder-empty]");
        this.onSearch = this.onSearch.bind(this);

        this.grid.addEventListener("change", this.onGridChange);
        this.chips?.addEventListener("click", this.onChipClick);
        this.addEventListener("change", this.onSizeChange);
        this.moreButton?.addEventListener("click", () => this.expandGrid());
        this.addEventListener("shopify:block:select", this.onBlockSelect);
        this.searchInput?.addEventListener("input", this.onSearch);

        // Capture fazi SART. product-form.js submit'i BUBBLE fazinda dinliyor ve
        // hangi custom element'in once upgrade edildigi garanti degil. Capture +
        // stopImmediatePropagation olmadan, eksik secimle sepete ekleme ara ara
        // gecebiliyor - yakalanmasi cok zor bir hata.
        this.form.addEventListener("submit", this.onSubmitCapture, { capture: true });

        this.restore();
        this.setupCollapse();
        this.render();
        this.augment();
      }

      /**
       * Liquid'de collection.products en fazla 50 urun donduruyor. Koleksiyonda
       * daha fazlasi varsa kalanini koleksiyon JSON'undan cekip karo olarak ekler.
       * Sunucu render'i tek basina calisir; bu yalnizca ustune tamamlar.
       */
      async augment() {
        const handle = this.dataset.collectionHandle;
        const total = Number(this.dataset.collectionCount) || 0;
        const shown = this.tiles().length;
        if (!handle || total <= shown) return;

        const qualify = (this.dataset.qualifyTitle || "5 ML").trim().toUpperCase();
        const hideSoldOut = this.dataset.hideSoldOut === "true";
        const seen = new Set(this.tiles().map((t) => t.dataset.handle));

        try {
          for (let page = 1; page <= 6; page++) {
            const res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`);
            if (!res.ok) return;
            const { products } = await res.json();
            if (!products || !products.length) return;

            products.forEach((product) => {
              if (seen.has(product.handle)) return;
              const variant = product.variants.find(
                (v) => String(v.title).trim().toUpperCase() === qualify,
              );
              if (!variant) return; // sette sunulmuyor
              if (hideSoldOut && !variant.available) return;
              seen.add(product.handle);
              this.grid.append(this.buildTile(product, variant));
            });

            if (products.length < 250) break;
          }
        } catch (e) {
          // Sunucudan gelen ilk 50 karo zaten calisiyor; sessizce vazgec.
          return;
        }

        this.restore();
        this.render();
        this.setupCollapse();
        // Sonradan eklenen karolar da aktif aramaya uysun.
        if (this.searchInput?.value) this.applyFilter();
      }

      buildTile(product, variant) {
        const index = this.tiles().length + 1;
        const id = `Scent-x-${index}`;

        const li = document.createElement("li");
        li.className = "set-builder__tile" + (variant.available ? "" : " is-unavailable");
        li.dataset.handle = product.handle;
        li.dataset.title = product.title;
        li.dataset.available = String(!!variant.available);

        const input = document.createElement("input");
        input.type = "checkbox";
        input.id = id;
        input.setAttribute("data-set-builder-tile-input", "");
        if (!variant.available) input.disabled = true;

        const label = document.createElement("label");
        label.htmlFor = id;

        const order = document.createElement("span");
        order.className = "set-builder__tile-order";
        order.setAttribute("aria-hidden", "true");
        label.append(order);

        // products.json gorselleri obje olarak donuyor ({id, src, ...});
        // bazi baglamlarda duz string gelebiliyor - ikisini de karsila.
        const first = product.images && product.images[0];
        const src = first && (typeof first === "string" ? first : first.src);
        if (src) {
          const img = document.createElement("img");
          // Shopify CDN boyut eki: dosya adina _400x eklenir.
          img.src = String(src).replace(/(\.[a-zA-Z]+)(\?|$)/, "_400x$1$2");
          img.loading = "lazy";
          img.alt = "";
          label.append(img);
        }

        const title = document.createElement("span");
        title.className = "set-builder__tile-title";
        title.textContent = product.title;
        label.append(title);

        li.append(input, label);
        return li;
      }

      disconnectedCallback() {
        this.grid?.removeEventListener("change", this.onGridChange);
        this.chips?.removeEventListener("click", this.onChipClick);
        this.removeEventListener("change", this.onSizeChange);
        this.removeEventListener("shopify:block:select", this.onBlockSelect);
        this.searchInput?.removeEventListener("input", this.onSearch);
        this.form?.removeEventListener("submit", this.onSubmitCapture, { capture: true });
        clearTimeout(this.searchTimer);
      }

      /* ---------------- secim ---------------- */

      tiles() {
        return [...this.grid.querySelectorAll(".set-builder__tile")];
      }

      tileFor(handle) {
        return this.grid.querySelector(`.set-builder__tile[data-handle="${CSS.escape(handle)}"]`);
      }

      onGridChange(event) {
        const input = event.target.closest("[data-set-builder-tile-input]");
        if (!input) return;
        const tile = input.closest(".set-builder__tile");
        if (!tile) return;

        const handle = tile.dataset.handle;
        const alreadyPicked = this.picks.includes(handle);

        if (alreadyPicked && !this.allowDupes) {
          this.picks = this.picks.filter((h) => h !== handle);
        } else if (this.picks.length >= this.max) {
          // Karolari devre disi BIRAKMIYORUZ: tik kabul edilip geri aliniyor ve
          // sebebi sesli duyuruluyor. Devre disi birakmak klavye kullanicisini
          // odak sirasindan cikarir ve kurali ogrenmesini engeller.
          input.checked = false;
          this.warn(this.interpolate(this.dataset.limitText));
          return;
        } else {
          this.picks.push(handle);
        }

        this.persist();
        this.render();
      }

      onChipClick(event) {
        const button = event.target.closest("[data-remove-handle]");
        if (!button) return;
        const handle = button.dataset.removeHandle;
        const index = this.picks.indexOf(handle);
        this.picks = this.picks.filter((h) => h !== handle);
        this.persist();
        this.render();

        // Odak bosluga dusmesin: sonraki chip, yoksa sayac.
        const next = this.chips.querySelectorAll("[data-remove-handle]")[index];
        (next || this.counter)?.focus?.();
      }

      onSizeChange(event) {
        const radio = event.target.closest("[name^='set-size-']");
        if (!radio) return;
        this.size = { id: radio.dataset.variantId, label: radio.dataset.label };
        if (this.variantInput) this.variantInput.value = radio.dataset.variantId;

        const priceWrap = this.querySelector("[data-set-builder-price]");
        const current = this.querySelector("[data-set-builder-price-current]");
        const compare = this.querySelector("[data-set-builder-price-compare]");
        if (current) current.textContent = radio.dataset.price || "";
        if (compare) compare.textContent = radio.dataset.compare || "";
        priceWrap?.classList.toggle("set-builder__price--on-sale", !!radio.dataset.compare);

        this.persist();
        this.render();
      }

      onBlockSelect(event) {
        const radio = event.target.querySelector?.("[name^='set-size-']");
        if (radio && !radio.disabled) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      /* ---------------- ciktilar ---------------- */

      render() {
        this.renderTiles();
        this.renderChips();
        this.renderCounter();
        this.renderButton();
        this.syncFormInputs();
      }

      renderTiles() {
        this.tiles().forEach((tile) => {
          const input = tile.querySelector("[data-set-builder-tile-input]");
          const order = tile.querySelector(".set-builder__tile-order");
          const index = this.picks.indexOf(tile.dataset.handle);
          if (input) input.checked = index !== -1;
          if (order) order.textContent = index === -1 ? "" : String(index + 1);
        });
      }

      renderChips() {
        if (!this.chips) return;
        this.chips.innerHTML = "";
        this.picks.forEach((handle) => {
          const tile = this.tileFor(handle);
          const title = tile?.dataset.title || handle;
          const li = document.createElement("li");
          li.className = "set-builder__chip";
          const span = document.createElement("span");
          span.textContent = title;
          const button = document.createElement("button");
          button.type = "button";
          button.dataset.removeHandle = handle;
          button.setAttribute("aria-label", `${title} kaldır`);
          button.textContent = "×";
          li.append(span, button);
          this.chips.append(li);
        });
      }

      renderCounter() {
        if (!this.counter) return;
        this.counter.classList.remove("set-builder__counter--warn");
        this.counter.textContent = this.interpolate(this.dataset.counterText);
      }

      renderButton() {
        const complete = this.isComplete();
        if (this.submitButton) {
          if (complete) this.submitButton.removeAttribute("aria-disabled");
          else this.submitButton.setAttribute("aria-disabled", "true");
        }
        if (this.ctaLabel) {
          this.ctaLabel.textContent = complete
            ? this.dataset.completeText || "Sepete ekle"
            : this.interpolate(this.dataset.incompleteText);
        }
      }

      /**
       * Gizli property alanlarini HER SEFERINDE sifirdan kurar.
       * Bosaltmak yerine silip yeniden yaratmak sart: cart-item.liquid bos
       * degerli property'leri atliyor ama BAYAT dolu bir deger yanlis kokuyu
       * siparise gonderirdi.
       */
      syncFormInputs() {
        if (!this.propsHost) return;
        this.propsHost.innerHTML = "";
        const prefix = this.dataset.propertyPrefix || "Koku";

        this.picks.forEach((handle, i) => {
          const title = this.tileFor(handle)?.dataset.title || handle;
          this.propsHost.append(this.hidden(`properties[${i + 1}. ${prefix}]`, title));
        });

        if (this.size.label) {
          // Alt cizgiyle baslayan property'ler sepette gizli, siparişte gorunur.
          this.propsHost.append(this.hidden("properties[_set_boyut]", this.size.label));
        }
      }

      hidden(name, value) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        return input;
      }

      /* ---------------- gonderim ---------------- */

      onSubmitCapture(event) {
        if (this.isComplete()) {
          // Drawer kapatildiginda odak butona donsun.
          document.querySelector("cart-drawer")?.rememberOpener?.({ currentTarget: this.submitButton });
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        this.warn(this.interpolate(this.dataset.incompleteText));
        this.focusFirstUnselected();
      }

      isComplete() {
        return this.picks.length === this.max;
      }

      focusFirstUnselected() {
        // Aramayla gizlenmis karo odaklanamaz; yalnizca gorunur olanlara bak.
        const tile = this.tiles().find(
          (t) =>
            !this.picks.includes(t.dataset.handle) &&
            t.dataset.available === "true" &&
            !t.classList.contains("is-filtered"),
        );
        tile?.querySelector("[data-set-builder-tile-input]")?.focus();
      }

      /* ---------------- arama ---------------- */

      /**
       * Turkce duyarli arama anahtari.
       *
       * Naif toLowerCase() burada yetmiyor: 'İ'.toLowerCase() JS'de birlesik
       * noktali bir karakter uretiyor ve 'i' ile eslesmiyor. Ayrica musteri
       * "gul" yazip "GÜL"u bulabilmeli. Cozum: Turkce yerel kucultme + NFD ile
       * aksan ayirma + kalan Turkce harflerin ASCII karsiligina indirgenmesi.
       */
      normalize(value) {
        return String(value || "")
          .toLocaleLowerCase("tr")
          .normalize("NFD")
          .replace(/[̀-ͯ]/g, "")
          .replace(/ı/g, "i")
          .replace(/ş/g, "s")
          .replace(/ğ/g, "g")
          .replace(/ç/g, "c")
          .replace(/ö/g, "o")
          .replace(/ü/g, "u")
          .trim();
      }

      onSearch() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.applyFilter(), 180);
      }

      applyFilter() {
        const query = this.normalize(this.searchInput?.value);
        let matches = 0;

        this.tiles().forEach((tile) => {
          // Normalize edilmis basligi karo uzerinde onbellekle.
          if (!tile.dataset.search) tile.dataset.search = this.normalize(tile.dataset.title);
          const hit = !query || tile.dataset.search.includes(query);
          tile.classList.toggle("is-filtered", !hit);
          if (hit) matches += 1;
        });

        // Arama sirasinda listeyi ac: eslesenler kisaltma yuzunden
        // gizli kalirsa arama iseyaramaz hale gelir.
        if (query) this.expandGrid();

        if (this.emptyMessage) this.emptyMessage.hidden = matches !== 0;
        if (this.searchStatus && query) {
          this.searchStatus.textContent = String(this.dataset.searchStatusText || "||count||")
            .replace(/\|\|count\|\|/g, matches);
        } else if (this.searchStatus) {
          this.searchStatus.textContent = "";
        }
      }

      /* ---------------- yardimcilar ---------------- */

      interpolate(template) {
        const selected = this.picks.length;
        // Yer tutucu bicimi ||ad||. Tema ayarlarinda {{ }} kullanilamiyor:
        // Shopify onu dinamik kaynak baglamasi sanip sablonu reddediyor.
        return String(template || "")
          .replace(/\|\|selected\|\|/g, selected)
          .replace(/\|\|total\|\|/g, this.max)
          .replace(/\|\|remaining\|\|/g, Math.max(0, this.max - selected));
      }

      warn(message) {
        if (!this.counter) return;
        this.counter.textContent = message;
        this.counter.classList.remove("set-builder__counter--warn");
        void this.counter.offsetWidth; // animasyonu yeniden tetikle
        this.counter.classList.add("set-builder__counter--warn");
      }

      storageKey() {
        return `set-builder:${this.closest("[data-section-id]")?.dataset.sectionId || "default"}`;
      }

      persist() {
        try {
          sessionStorage.setItem(
            this.storageKey(),
            JSON.stringify({ picks: this.picks, sizeId: this.size.id }),
          );
        } catch (e) {
          /* private mode / kota: kalicilik olmasin, akis bozulmasin */
        }
      }

      restore() {
        try {
          const raw = sessionStorage.getItem(this.storageKey());
          if (!raw) return;
          const saved = JSON.parse(raw);
          if (!Array.isArray(saved.picks)) return;
          // Yalnizca hala sayfada olan ve stokta kalan kokulari geri yukle.
          this.picks = saved.picks
            .filter((h) => {
              const tile = this.tileFor(h);
              return tile && tile.dataset.available === "true";
            })
            .slice(0, this.max);
        } catch (e) {
          /* bozuk kayit: temiz baslat */
        }
      }

      /* ---------------- mobilde listeyi kisalt ---------------- */

      setupCollapse() {
        if (!this.moreButton) return;
        // Kullanici listeyi actiysa bir daha kapatma (augment() sonrasi
        // ikinci kez cagriliyor).
        if (this.expanded) return;
        const rows = Number(this.dataset.collapsedRows) || 3;
        const cols = getComputedStyle(this.grid).gridTemplateColumns.split(" ").length;
        if (this.tiles().length <= rows * cols) return; // kisaltmaya gerek yok

        this.grid.classList.add("set-builder__grid--collapsed");
        const tile = this.tiles()[0];
        const gap = parseFloat(getComputedStyle(this.grid).rowGap) || 12;
        this.grid.style.maxHeight = `${rows * tile.offsetHeight + (rows - 1) * gap}px`;
        this.moreButton.hidden = false;
      }

      expandGrid() {
        this.expanded = true;
        this.grid.classList.remove("set-builder__grid--collapsed");
        this.grid.style.maxHeight = "";
        this.moreButton.hidden = true;
      }
    },
  );
}
